import instance from './require'

// 获取订单接口
const order = {
  // 获取全部订单
  getOrder(name, value, data) {
    return instance.get(`newm/order/get-list?${name}=${value}`, {
        params: data
      }).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },

  closeOrder(data) {
    return instance.post('/order/index/close', data).then(res => {
        return Promise.resolve(res)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
}

export default order



// WEBPACK FOOTER //
// ./src/utils/getOrder.js